import React, { useEffect, useState } from "react";
import "./SliderFile.css";
import { withStyles } from "@material-ui/core/styles";
import Slider from "@material-ui/core/Slider";
import filedata from "../BubbleChart/filedata";
import { useParams } from "react-router-dom";
import File from "./File";
import SliderHome from "./SliderHome";
import ServerModal from "./ServerModal";

const Container = () => {
  const { pathid, subid } = useParams();
  const [sliderdata, setsliderdata] = useState({});
  const [objectdata, setobjectdata] = useState([]);
  useEffect(() => {
    const val = filedata.Wholedata.filter((data) => data.id === pathid);
    const arr = val[0].data;
    const spreadedarr = arr.filter((data) => data.id === subid);
    setsliderdata(spreadedarr[0]);
    setobjectdata(spreadedarr[0].data);
  }, [sliderdata, objectdata, pathid, subid]);
  return (
    <div className="outerContainer">
      <ServerModal />
      <center>
        <h1>{sliderdata.name}</h1>
      </center>

      {objectdata.map((data_value) => {
        return (
          <>
            {data_value.chunk.map((inside_data) => {
              return (
                <>
                  <div>
                    <div className="leftSection">
                      {inside_data.headingData.map((in_data) => {
                        return (
                          <div>
                            <h4 className="slider111">
                              <div className="slider-objective">
                                <b>OBJECTIVE :</b> {in_data.objective}
                              </div>
                              <div className="rightSection">
                                <SliderHome
                                  value={45}
                                  min={0}
                                  max={100}
                                  data_type={"%"}
                                />
                              </div>
                            </h4>
                            <File in_data={in_data} />
                            <hr></hr>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </>
              );
            })}
          </>
        );
      })}
    </div>
  );
};

export default Container;
